import React from "react";
import { useTranslation } from "react-i18next";

import styles from "./g-error.module.scss";

type ErrorProps = {
  warn?: boolean;
  message?: string;
};

const ErrorBanner: React.FC<ErrorProps> = ({
  warn = false,
  message = "An unknown error occured",
}) => {
  const { t } = useTranslation();

  if (warn && message) {
    return (
      <div className={styles["g-error__validation"]}>
        <div className={styles["g-error__validation__text"]}>{t(message)}</div>
      </div>
    );
  } else {
    return null;
  }
};

export default ErrorBanner;
